import { useContext, createContext, useEffect, useState, useRef } from 'react';
import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import requestHandler from '../utils/requestHandler';
import { auth } from '../firebase';

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({isPreviouslyAuthenticated: true});

  const googleSignIn = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider);
    // signInWithRedirect(auth, provider)
  };

  const logOut = () => {
      signOut(auth)
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {

      const getUserFromDB = async () => {
        try{
        if(currentUser === null || currentUser.accessToken === undefined || currentUser.email === undefined) {
          setUser({isPreviouslyAuthenticated: false});
          return;
        }

        const result = await requestHandler(`users/${currentUser.email.split("@")[0]}`,"GET", "Bearer " + currentUser.accessToken);

        if(result === null) {
          return;
        }
        
        currentUser.isAdmin = result.groups.includes("Admins")
        
        for(const [resKey, value] of Object.entries(result))
          if(currentUser[resKey] === undefined)
            currentUser[resKey] = value;

        setUser(currentUser);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
      
      getUserFromDB();

    });
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ googleSignIn, logOut, user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(AuthContext);
};